<nz-modal
*appHasAnyPrivilege="'REPORT_GENERATE'"
  [(nzVisible)]="isVisibleGenerateInventoryReport"
  nzTitle="Generate Report"
  (nzOnCancel)="handleCancelGenerateInventoryReport()"
  (nzOnOk)="handleOkGenerateInventoryReport()">
  <ng-container *nzModalContent>
    <div *ngIf="isLoading">
      <p class="text-primary">Loading...</p>
    </div>
    <div *ngIf="!isLoading && haveRecord && haveBeforeDetails && haveAfterDetails" class="flex justify-end gap-2">
      <button nz-button nzType="primary" (click)="setSelectedDetails('before')">Before Details</button>
      <button nz-button nzType="primary" (click)="setSelectedDetails('after')">After Details</button>
    </div>
    <div *ngIf="!isLoading && haveRecord && optionSelected">
      <h6 class="mb-1 subject-data">{{recordType}} Record</h6>
      <p class="mb-1 subject-data">Edit Remarks</p>
      <textarea rows="5" nz-input [(ngModel)]="editableRemarks"></textarea>
      <div class="flex justify-end my-2">
        <button nz-button nzType="primary"
                nz-popconfirm
                nzPopconfirmTitle="Are you sure want to update inventory remarks?"
                nzOkText="Ok"
                nzCancelText="Cancel"
                (nzOnConfirm)="handleUpdateInventoryRecord()"
                (nzOnCancel)="handleCancel()" [disabled]="editableRemarks === recordRemark">Save
        </button>
      </div>
    </div>
    <div *ngIf="!generating && !isLoading && !haveRecord">
      <p class="text-primary">No inspection record for that vehicle yet...</p>
    </div>
    <div *ngIf="generating">
      <p class="text-primary">Generating...</p>
    </div>
  </ng-container>
  <div *nzModalFooter class="flex justify-between">
    <button *appHasAnyPrivilege="''" nz-button nzType="primary" (click)="generateReport()"
            [disabled]="editableRemarks !== recordRemark || isPdfGenerated || !haveRecord" [nzLoading]="generating">Generate
    </button>
    <div class="sm:gap-2">
      <button *appHasAnyPrivilege="''" nz-button nzType="default" (click)="previewReport()"
              [disabled]="editableRemarks !== recordRemark || !isPdfGenerated">Preview
      </button>
      <button *appHasAnyPrivilege="''" nz-button nzType="default" (click)="printReport()"
              [disabled]="editableRemarks !== recordRemark || !isPdfGenerated">Print
      </button>
      <button *appHasAnyPrivilege="''" nz-button nzType="default"
              [disabled]="editableRemarks !== recordRemark || !isPdfGenerated" (click)="emailPdf()">
        Send
      </button>
      <button *appHasAnyPrivilege="''" nz-button nzType="default" (click)="downloadReport()"
              [disabled]="editableRemarks !== recordRemark || !isPdfGenerated" [nzLoading]="downloading">
        Download
      </button>
    </div>
  </div>
</nz-modal>
